import { httpRequest } from "@services/http";
import { AudienceMembersPage } from "@models/audienceMember.model";

export class CommandListAudienceMembers {
  async run(
    audienceId: number,
    limit: number,
    offset: number,
  ): Promise<AudienceMembersPage> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/audiences/${audienceId}/members/?limit=${limit}&offset=${offset}`;
    return await httpRequest<AudienceMembersPage>(url, { method: "GET", cache: "no-store" });
  }
}
